module.exports = __webpack_public_path__ + "static/media/noun-parking-2946816-808080.4e2230e9.svg";